import { jsx as _jsx } from "react/jsx-runtime";
function CeloIcon() {
    return (_jsx("svg", { className: "ui-size-full", viewBox: "0 0 22 23", fill: "currentColor", children: _jsx("path", { d: "M21.8597 0.801025H0V22.801H21.8593V15.1215H18.2316C16.981 17.923 14.1663 19.8743 10.9451 19.8743C6.50438 19.8743 2.90811 16.2237 2.90811 11.7856C2.90811 7.34758 6.50438 3.72824 10.9451 3.72824C14.2288 3.72824 17.0435 5.7427 18.2945 8.60662H21.8597V0.801025Z" }) }));
}
export default CeloIcon;
